// removed by extract-text-webpack-plugin
module.exports = {"form":"styles__form___X-HFh","form-input":"styles__form-input___3wbh4","form-textarea":"styles__form-textarea___3k2se","inputWrapper":"styles__inputWrapper___3J-Tm","inputLabel":"styles__inputLabel___vs9WZ","inputElement":"styles__inputElement___3Ip7Y","button":"styles__button___2YCe0"};


//////////////////
// WEBPACK FOOTER
// ./src/views/log/summary/styles.css
// module id = 884
// module chunks = 0